import { jwtDecode } from "jwt-decode"

export const decodeJwt = <T>(access_token: string) => {
  return jwtDecode(access_token) as T
}
